import React, { Component } from 'react';
import { withRouter } from "react-router";
import LayoutMapper from '../../components/LayoutMapper/LayoutMapper.component';
import { PageSettings } from './../../config/page-settings.js';

class PublicBuildingZoneLayout extends Component {
  static contextType = PageSettings;

  constructor(props) {
    super(props);

    const query = new URLSearchParams(this.props.location.search);
    
    this.state = {
      // token: props.token,
      // selectedLayout: props.id
      selectedLayout: this.props.match.params.id,
      token: query.get('token')
    };
    this.initialState = this.state;
  }

  componentDidMount() {
		this.context.handleSetPageSidebar(false);
		this.context.handleSetPageHeader(false);
		this.context.handleSetBodyWhiteBg(true);
		this.context.handleSetPageContentClass('p-0');
	}

	componentWillUnmount() {
		this.context.handleSetPageSidebar(true);
		this.context.handleSetPageHeader(true);
		this.context.handleSetPageContentClass('');
		this.context.handleSetBodyWhiteBg(false);
	}

  render() {
    return (
      <LayoutMapper selectedLayout={this.state.selectedLayout} token={this.state.token} />
    );
  }
}

export default withRouter(PublicBuildingZoneLayout);
